export enum LeadStatus {
  NEW = "New",
  CONTACTED = "Contacted",
  QUALIFIED = "Qualified",
  UNQUALIFIED = "Unqualified",
  COLD = "Cold",
}
